import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import { get } from "lodash";

import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";

import Instructions from "./Instructions";
import CloseIcon from "../../Common/CloseIcon";

import {
  VERIFICATION_THREAT,
  VERIFICATION_WARNING,
  VERIFICATION_OK,
} from "../../../constants/eventGroups";

import { getAttributeName, getAttributeValue } from "../../../utils/profile";

import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";

const styles = (theme) => ({
  closeIcon: {
    display: "flex",
    justifyContent: "flex-end",
  },
  dialogPaper: {
    [theme.breakpoints.down("sm")]: {},
    [theme.breakpoints.up("sm")]: {
      minWidth: "500px",
      maxWidth: "500px",
      maxHeight: "900px",
    },
  },
  link: {
    color: colors.primary,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
});

const InstructionsDialog = (props) => {
  const {
    classes,
    surveyStatus,
    profileName,
    lukeAction,
    lov,
    language,
  } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <span onClick={() => setOpen(true)} className={classes.link}>
        {lukeAction
          ? getAttributeValue(lukeAction, 158, lov, language)
          : [VERIFICATION_WARNING, VERIFICATION_THREAT].includes(surveyStatus)
          ? I18n.get("profiles_covidMsgWarning2")
          : I18n.get("profiles_covidMsgClear2")}
      </span>
      <Dialog open={open} classes={{ paper: classes.dialogPaper }}>
        <Grid
          container
          wrap="nowrap"
          direction="column"
          alignItems="stretch"
          style={{ height: "100%", padding: "12px" }}
        >
          <Grid item>
            <Grid container alignItems="center">
              <Grid item xs={2} />
              <Grid item xs className="text-87 bold-500">
                <Grid container justify="center" alignItems="center">
                  <Grid item style={{ width: "30px" }}>
                    <img src={images.humanIconBlack} alt="human" />
                  </Grid>
                  <Grid item>{profileName}</Grid>
                </Grid>
              </Grid>
              <Grid item xs={2} className={classes.closeIcon}>
                <CloseIcon closeFunction={() => setOpen(false)} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item className="text-center text-87">
            {getAttributeName(
              { attributes: get(lov, ["eventTypes"]) },
              81,
              language
            )}
          </Grid>
          <Instructions
            profileName={profileName}
            surveyStatus={surveyStatus}
            lukeActionId={getAttributeValue(lukeAction, 158)}
            lov={lov}
            language={language}
          />
        </Grid>
      </Dialog>
    </>
  );
};

InstructionsDialog.propTypes = {
  surveyStatus: PropTypes.oneOf([
    VERIFICATION_OK,
    VERIFICATION_WARNING,
    VERIFICATION_THREAT,
  ]),
  profileName: PropTypes.string.isRequired,
};

export default withStyles(styles)(InstructionsDialog);
